/**
 * Atlas article enhancement for Shopify blog content.
 *
 * 1. Marks blog content as .atlas-article when .atlas-toc is present
 * 2. Wraps <!-- section: name --> comments into .atlas-section divs
 * 3. Falls back to wrapping content by h2 headings (real Atlas assembler output)
 */
(function () {
  const SECTION_COMMENT = /^section:\s*([\w_]+)\s*$/;

  /** Map h2 id slugs to css-classes.md section names */
  const H2_ID_ALIASES = {
    'quick-answer': 'quick_answer',
    'key-takeaways': 'key_takeaways',
    'side-by-side-comparison': 'side_by_side_comparison',
    'what-a-shop-vac-does-on-the-jobsite': 'option_a_overview',
    'what-a-shop-vac-does-on-the-job': 'option_b_overview',
    'key-differences-that-matter-on-the-job': 'key_differences',
    'best-use-cases': 'best_use_cases',
    'pros-and-cons': 'pros_and_cons',
    'cost-and-ownership-considerations': 'cost_or_ownership_considerations',
    'decision-framework': 'decision_framework',
    'ctd-product-recommendations': 'product_recommendations',
    'related-articles': 'related_articles',
    'faqs': 'faqs',
    'next-step-match-the-vac-to-the-job': 'cta',
    'who-this-guide-is-for': 'who_this_guide_is_for',
    'buying-factors': 'buying_factors',
    'specs-explained': 'specs_explained',
    'tool-type-breakdown': 'tool_type_breakdown',
    'job-type-selection-matrix': 'job_type_selection_matrix',
    'must-have-accessories': 'must_have_accessories',
    'what-to-avoid': 'what_to_avoid',
    'what-it-is': 'what_it_is',
    'how-it-works': 'how_it_works',
    'types-or-options': 'types_or_options',
    'specs-or-features-explained': 'specs_or_features_explained',
    'when-to-use-it': 'when_to_use_it',
    'application-guidance': 'application_guidance',
    'compatibility-notes': 'compatibility_notes',
    'common-mistakes': 'common_mistakes',
    'selection-guidance': 'selection_guidance',
    'related-accessories-or-consumables': 'related_accessories_or_consumables',
  };

  function findNextSectionComment(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_COMMENT);
    let node = walker.nextNode();

    while (node) {
      if (SECTION_COMMENT.test(node.textContent.trim())) {
        return node;
      }
      node = walker.nextNode();
    }

    return null;
  }

  function resolveSectionName(h2, isFirstH2) {
    const id = h2.id;

    if (id && H2_ID_ALIASES[id]) {
      return H2_ID_ALIASES[id];
    }

    if (id) {
      return id.replace(/-/g, '_');
    }

    if (isFirstH2) {
      return 'intro';
    }

    return h2.textContent
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_|_$/g, '');
  }

  function createSectionWrapper(sectionName) {
    const wrapper = document.createElement('div');
    wrapper.className = `atlas-section ${sectionName}`;
    wrapper.dataset.section = sectionName;
    return wrapper;
  }

  function wrapSectionsFromComments(article) {
    let comment = findNextSectionComment(article);
    let wrapped = false;

    while (comment) {
      wrapped = true;
      const match = comment.textContent.trim().match(SECTION_COMMENT);
      if (!match) {
        break;
      }

      const wrapper = createSectionWrapper(match[1]);
      comment.parentNode.insertBefore(wrapper, comment);
      comment.remove();

      while (wrapper.nextSibling) {
        const sibling = wrapper.nextSibling;

        if (
          sibling.nodeType === Node.COMMENT_NODE &&
          SECTION_COMMENT.test(sibling.textContent.trim())
        ) {
          break;
        }

        wrapper.appendChild(sibling);
      }

      comment = findNextSectionComment(article);
    }

    return wrapped;
  }

  function isSectionBoundary(node) {
    if (!node || node.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    if (node.tagName === 'H2') {
      return true;
    }

    return node.classList && node.classList.contains('atlas-toc');
  }

  function wrapSectionsFromHeadings(article) {
    if (article.querySelector('.atlas-section')) {
      return;
    }

    let isFirstH2 = true;
    let node = article.firstElementChild;

    while (node) {
      const current = node;
      const next = current.nextElementSibling;

      if (current.tagName === 'H2') {
        const sectionName = resolveSectionName(current, isFirstH2);
        const wrapper = createSectionWrapper(sectionName);

        if (isFirstH2) {
          wrapper.classList.add('intro');
        }

        article.insertBefore(wrapper, current);
        wrapper.appendChild(current);
        isFirstH2 = false;

        while (wrapper.nextElementSibling && !isSectionBoundary(wrapper.nextElementSibling)) {
          wrapper.appendChild(wrapper.nextElementSibling);
        }

        node = wrapper.nextElementSibling;
        continue;
      }

      if (current.classList.contains('atlas-toc')) {
        const wrapper = createSectionWrapper('table_of_contents');
        article.insertBefore(wrapper, current);
        wrapper.appendChild(current);
        node = wrapper.nextElementSibling;
        continue;
      }

      node = next;
    }
  }

  function processAtlasArticle(article) {
    if (article.dataset.sectionsWrapped === 'true') {
      return;
    }

    const usedComments = wrapSectionsFromComments(article);

    if (!usedComments) {
      wrapSectionsFromHeadings(article);
    }

    article.dataset.sectionsWrapped = 'true';
  }

  function initAtlasArticles() {
    document.querySelectorAll('.article-template__content.rte').forEach((content) => {
      if (content.querySelector('.atlas-toc') || content.querySelector('.atlas-article')) {
        content.classList.add('atlas-article');
      }
    });

    document.querySelectorAll('.atlas-article').forEach(processAtlasArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAtlasArticles);
  } else {
    initAtlasArticles();
  }
})();
